function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M-99.3,380.2h-20.4l-6,10.8h32.4L-99.3,380.2z M-127,375.8l-10.4-17.2h-12l16,28L-127,375.8z M-69.3,358.2h-12.4l-10,17.2 l6.4,10.8L-69.3,358.2z M-119.4,371.4h20.4l10-17.6l-10-17.6h-20.4l-10,17.6L-119.4,371.4z M-103.3,343.4l6,10.4l-6,10.4h-12 l-6-10.4l6-10.4H-103.3z M-149.4,349.4h12l10-17.2l-6-10.8L-149.4,349.4z M-91.7,332.2l10,17.2h12.4l-16-28L-91.7,332.2z  M-119.4,327.8h20.4l6-10.8h-32.4L-119.4,327.8z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M-98.6,466.2h-20.4l-6,10.8h32.4L-98.6,466.2z M-126.3,461.8l-10.4-17.2h-12l16,28L-126.3,461.8z M-68.6,444.2H-81l-10,17.2 l6.4,10.8L-68.6,444.2z M-118.7,457.4h20.4l10-17.6l-10-17.6h-20.4l-10,17.6L-118.7,457.4z M-102.6,429.4l6,10.4l-6,10.4h-12 l-6-10.4l6-10.4H-102.6z M-148.7,435.4h12l10-17.2l-6-10.8L-148.7,435.4z M-91,418.2l10,17.2h12.4l-16-28L-91,418.2z M-118.7,413.8 h20.4l6-10.8h-32.4L-118.7,413.8z"
});

var SvgSwrpgThreatThreat = function SvgSwrpgThreatThreat(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "-207 299 196 196",
    style: {
      enableBackground: "new -207 299 196 196"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSwrpgThreatThreat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/swrpg-threat-threat.73de0e9b.svg";
export { ForwardRef as ReactComponent };